export const trackLoggedIn = (() => {
    const loggedIn = document.cookie.includes('e7MembersOnline');

    window.dataLayer.push({
        event: 'Member Portal Logged In',
        value: loggedIn
    });
})();

export const trackPromos = (() => {
    const promo = document.querySelector('.Promo');

    if (promo) {
        const textAboveFold = promo.querySelector('.Promo__text-above-fold').innerText;
        const expandText = promo.querySelector('.Promo__expand-text').innerText;
        const track = (event) => {
            console.log(event, `${textAboveFold} | ${expandText}`);
            window.dataLayer.push({
                event,
                click_text: `${textAboveFold} | ${expandText}`
            });
        };

        track('accordion_banner_view');

        promo.addEventListener('toggledOn', () => {
            track('accordion_banner_expand');
        });

        promo.addEventListener('toggledOff', () => {
            track('accordion_banner_close');
        });
    }
})();
